import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  FaUserTie,
  FaBriefcase,
  FaGavel,
  FaChild,
  FaClock,
  FaGlobeEurope,
  FaRupeeSign,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "../CaseResult/Results.css";
import Resultp from "./Result-p";

const Results = () => {
  const { id } = useParams();

  const cases = [
    {
      id: 1,
      category: "Family Law",
      name: "Family Violence Protection Case",
      highlightedTags: [
        "Domestic Violence",
        "Protection Order",
        "Child Safety",
        "Family Law",
        "Legal Advocacy",
      ],
      image: "/fvp.webp",
      description:
        "Secured comprehensive protection for domestic violence survivors, establishing legal safeguards and safe living arrangements for affected families.",
      gridCards: [
        {
          icon: <FaBriefcase />,
          title: "Case Type",
          text: "Domestic Violence",
        },
        {
          icon: <FaClock />,
          title: "Time Taken",
          text: "3 Months",
        },
        {
          icon: <FaUserTie />,
          title: "Lawyer",
          text: "Sarah Johnson",
        },
        {
          icon: <FaGavel />,
          title: "Result",
          text: "Full Protection",
        },
      ],
      about:
        "This urgent matter required immediate ex parte protection orders followed by permanent safeguards for a survivor and two children. We coordinated with women's shelters while gathering police reports, medical evidence, and witness testimony to build an irrefutable case.",
      challenges:
        "The respondent repeatedly violated temporary orders and used community influence to intimidate witnesses. We countered by securing courtroom protections and police enforcement protocols to maintain safety during litigation.",
      strategy:
        "Implemented a three-phase approach: emergency filings, systematic evidence collection, and long-term safety planning. Worked with child psychologists to develop trauma-informed visitation protocols that protected minors while preserving parental rights.",
      result:
        "Obtained maximum-duration protection orders with enhanced enforcement mechanisms. Secured exclusive home occupancy, ₹15 lakhs annual support. Set precedent for GPS monitoring in high-risk cases.",
      contact: {
        address: "123 Safety Lane, New Delhi",
        phone: "+91 98765 43210",
        email: "confidential@example.com",
      },
    },
    {
      id: 2,
      category: "Corporate Law",
      name: "Giving Million Air Its Wings",
      highlightedTags: [
        "Startup Defense",
        "Corporate Takeover",
        "IP Protection",
        "Aviation Law",
        "Market Position",
      ],
      image: "/pip.webp",
      description:
        "Defended aviation startup Million Air against hostile takeover, protecting intellectual property and securing market position.",
      gridCards: [
        {
          icon: <FaBriefcase />,
          title: "Case Type",
          text: "Corporate Defense",
        },
        {
          icon: <FaClock />,
          title: "Time Taken",
          text: "8 Months",
        },
        {
          icon: <FaUserTie />,
          title: "Lawyer",
          text: "Michael Chen",
        },
        {
          icon: <FaRupeeSign />,
          title: "Settlement",
          text: "₹2.5 Crore",
        },
      ],
      about:
        "This precedent-setting case involved defending Million Air against a larger competitor's multi-pronged attack combining dubious patent claims with below-market acquisition offers. The competitor simultaneously launched talent raids and predatory pricing.",
      challenges:
        "The opposing corporation used its market dominance to manipulate suppliers and investors while prolonging litigation. They filed parallel patent challenges in three countries to drain Million Air's resources and create existential threat.",
      strategy:
        "We filed counterclaims under India's new competition laws while securing emergency injunctions. Our forensic accounting team exposed bad-faith negotiations through internal document discovery and email trails.",
      result:
        "The settlement included ₹2.5 crore damages, cross-licensing agreements, and market non-interference commitments. Established that startups can claim treble damages for coercive acquisition attempts under Section 4 of Competition Act and we won this case successfully.",
      contact: {
        address: "Million Air HQ, Bangalore",
        phone: "+91 87654 32109",
        email: "legal@millionair.com",
      },
    },
    {
      id: 3,
      category: "Family Law",
      name: "Child Custody Protection",
      highlightedTags: [
        "Custody Battle",
        "Parental Rights",
        "Child Welfare",
        "Relocation",
        "Family Law",
      ],
      image: "/ccp.webp",
      description:
        "Prevented international child abduction by securing primary custody when ex-spouse attempted unlawful relocation.",
      gridCards: [
        {
          icon: <FaBriefcase />,
          title: "Case Type",
          text: "Custody Dispute",
        },
        {
          icon: <FaClock />,
          title: "Time Taken",
          text: "6 Months",
        },
        {
          icon: <FaUserTie />,
          title: "Lawyer",
          text: "Priya Sharma",
        },
        {
          icon: <FaChild />,
          title: "Outcome",
          text: "Primary Custody",
        },
      ],
      about:
        "This urgent international matter involved preventing a parent from relocating a child abroad without consent. The mother had already obtained foreign visas and booked flights when we filed emergency motions in family court.",
      challenges:
        "The case required simultaneous filings under the Hague Convention and domestic law. We had to coordinate with immigration authorities across three countries while addressing complex jurisdictional questions and we faced lots of miss coordination also with clients but we will proceed it.",
      strategy:
        "Obtained emergency passport surrender orders and airport watchlist alerts. Demonstrated how relocation would disrupt the child's education, healthcare, and relationship with the father's extended family.",
      result:
        "Court awarded primary custody to our client with stringent travel restrictions. Set precedent that unilateral relocation attempts constitute constructive custody denial under Article 3 of Hague Convention and we won this case successfully.",
      contact: {
        address: "456 Family Court Rd, Mumbai",
        phone: "+91 76543 21098",
        email: "confidential2@example.com",
      },
    },
    {
      id: 4,
      category: "Corporate Law",
      name: "Million Air Expansion Case",
      highlightedTags: [
        "Market Expansion",
        "Regulatory Compliance",
        "International Law",
        "Aviation",
        "Corporate Strategy",
      ],
      image: "/ilp.webp",
      description:
        "Facilitated Million Air's European expansion by navigating complex international aviation regulations successfully.",
      gridCards: [
        {
          icon: <FaBriefcase />,
          title: "Case Type",
          text: "Regulatory Compliance",
        },
        {
          icon: <FaClock />,
          title: "Time Taken",
          text: "5 Months",
        },
        {
          icon: <FaUserTie />,
          title: "Lawyer",
          text: "Arjun Patel",
        },
        {
          icon: <FaGlobeEurope />,
          title: "Markets Opened",
          text: "3 Countries",
        },
      ],
      about:
        "This complex project involved establishing Million Air's European operations while complying with diverse aviation regulations. We created country-specific legal entities and operational frameworks meeting EASA standards. This required deep engagement with local aviation bodies to align operational goals.",
      challenges:
        "Each country had different certification requirements, data laws, and operational restrictions. Germany required extensive drone safety documentation while France mandated local partnership structures. Coordinating these across multilingual legal systems was particularly demanding.",
      strategy:
        "Developed phased compliance roadmap addressing all regulatory layers: corporate structure, airworthiness certification, insurance requirements, and intellectual property protections under EU law. Conducted legal workshops and regulatory reviews to preempt approval delays.",
      result:
        "Successful market entry with zero regulatory violations. Established template for future expansions with 30% faster approval timelines. Protected patents through unified EU IP filings. Enabled smoother replication in subsequent EU markets.",

      contact: {
        address: "Million Air Intl, Delhi",
        phone: "+91 65432 10987",
        email: "expansion@millionair.com",
      },
    },
    {
      id: 5,
      category: "Corporate Law",
      name: "Corporate Fraud Defense Case",
      highlightedTags: [
        "White-Collar Crime",
        "Executive Defense",
        "Corporate Fraud",
        "Reputation Management",
        "Multinational Law",
      ],
      image: "/cfd.webp",
      description:
        "Defended a senior executive falsely accused of financial misconduct in a high-profile corporate fraud investigation, preserving reputation and career.",
      gridCards: [
        {
          icon: <FaBriefcase />,
          title: "Case Type",
          text: "Fraud Defense",
        },
        {
          icon: <FaClock />,
          title: "Time Taken",
          text: "4 Months",
        },
        {
          icon: <FaUserTie />,
          title: "Lawyer",
          text: "Neha Verma",
        },
        {
          icon: <FaGavel />,
          title: "Outcome",
          text: "All Charges Dropped",
        },
      ],
      about:
        "Our client, a CFO at a multinational tech firm, was accused of authorizing illegitimate transactions linked to a massive corporate fraud scheme. The internal audit report was flawed and the accusations were largely based on circumstantial evidence without context.",
      challenges:
        "We faced intense media scrutiny and pressure from the company’s board to resolve the issue quickly. Prosecutors were eager to make an example, and opposing counsel leaked misleading statements to financial news outlets to damage our client's credibility.",
      strategy:
        "We launched an aggressive internal investigation, hiring forensic accountants to audit the transaction trail. Simultaneously, we issued defamation warnings to media outlets and built a compelling narrative around our client's documented objections to questionable directives by other executives.",
      result:
        "All charges were dropped following presentation of exculpatory evidence. Our client was reinstated with full honors and received a public apology from the board. The case is now cited in corporate ethics training for best practices in internal investigations.",
      contact: {
        address: "Corporate Towers, Mumbai",
        phone: "+91 99887 77665",
        email: "confidential3@example.com",
      },
    },
  ];

  const [activeCase, setActiveCase] = useState(
    cases.find((c) => c.id === parseInt(id)) || cases[0],
  );

  const handleCaseClick = (caseId) => {
    const selectedCase = cases.find((c) => c.id === caseId);
    setActiveCase(selectedCase);
  };

  return (
    <>
      <Resultp />

      <div className="results-container">
        {/* Case Details Section */}
        <div className="case-details">
          <div className="left">
            <img src={activeCase.image} alt={activeCase.name} />
          </div>
          <div className="right">
            <p className="category">{activeCase.category}</p>
            <h3 className="h3-n">{activeCase.name}</h3>
            <p className="p-d">{activeCase.description}</p>
            {/* Grid Cards Section */}
            <div className="grid-cards">
              {activeCase.gridCards.map((card, index) => (
                <div className="grid-card" key={index}>
                  <div className="icon">{card.icon}</div>
                  <div className="c-pc">
                    <p className="c-pc-h">{card.title}</p>
                    <p>{card.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* About and Challenges Section */}
        <div className="info-section">
          <div className="left">
            <h3 className="info-h3">About This Case</h3>
            <p className="info-p">{activeCase.about}</p>
            <h3 className="info-h3">Challenges</h3>
            <p className="info-p">{activeCase.challenges}</p>
          </div>
          <div className="right">
            <div className="right-h">
              <h1 className="info-h3">Highlighted Tags</h1>
              <ul className="highlighted-tags">
                {activeCase.highlightedTags.map((tag, index) => (
                  <li key={index} className="tag-item">
                    {tag}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Legal Strategy and Results Section */}
        <div className="info-section">
          <div className="left">
            <h3 className="info-h3">Legal Strategy</h3>
            <p className="info-p">{activeCase.strategy}</p>
            <h3 className="info-h3">Results</h3>
            <p className="info-p">{activeCase.result}</p>
          </div>
          <div className="right">
            <div className="right-c">
              <h3 className="info-h3">Contact</h3>
              <p className="info-p">
                <FaMapMarkerAlt className="info-ic" />
                {activeCase.contact.address}
              </p>
              <p className="info-p">
                <FaPhoneAlt className="info-ic" /> {activeCase.contact.phone}
              </p>
              <p className="info-p">
                <FaEnvelope className="info-ic" /> {activeCase.contact.email}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Results;
